import { useInterval } from '@mantine/hooks';
import { Text } from '@repo/foundations';
import { useEffect, useState } from 'react';
import type { IDatabuilderJob } from '../../../../../api';
import { humanReadableTimeElapsed } from '../../../../../utils/time';
import {
	EXTRACTION_STATUS,
	getExtractionStatus,
} from '../../../IntegrationExtraction/utils';

function getJobDuration(job: IDatabuilderJob) {
	const status = getExtractionStatus(job);
	if (status === EXTRACTION_STATUS.queued) {
		if (job.stages?.length === 1) {
			return 'Queued';
		}
		if (job.stages?.length > 1) {
			return humanReadableTimeElapsed(
				Math.floor((Date.now() - new Date(job.created_at).getTime()) / 1000)
			);
		}
		return 'Verifying connection';
	}
	if (status === EXTRACTION_STATUS.running) {
		return humanReadableTimeElapsed(
			Math.floor((Date.now() - new Date(job.created_at).getTime()) / 1000)
		);
	}
	return humanReadableTimeElapsed(job.runtime);
}

export function SyncJobLiveDuration({ job }: { job: IDatabuilderJob }) {
	const [duration, setDuration] = useState(getJobDuration(job));

	const { start, stop } = useInterval(
		() => setDuration(getJobDuration(job)),
		500
	);

	useEffect(() => {
		if (getExtractionStatus(job) !== EXTRACTION_STATUS.running) {
			setDuration(getJobDuration(job));
			stop();
		} else {
			start();
		}
	}, [job, start, stop]);

	return <Text size="sm">{duration}</Text>;
}
